export default function round2(v: number): number {
  return Math.round(v * 100) / 100;
}
